import React from 'react';
import { connect } from 'react-redux';
import Webcam from './react-webcam';
import Button from 'semantic-ui-react/dist/commonjs/elements/Button';
import Modal from 'semantic-ui-react/dist/commonjs/modules/Modal';
import Image from 'semantic-ui-react/dist/commonjs/elements/Image';
import PropTypes from 'prop-types';
import './webcam-capture.css';
import { DEVICE_MOBILE, SCREEN_NAME_PHOTO_UPLOAD } from '../../utils/constants';
import { UploadButtonContainer } from '../../../src/screens/user-flow/individual/revampedUserFlow/styles';
import CommonButton from '../common-button/CommonButton';
import { CAMERA_FLIP_ICON, CAMERA_ICON, UPLOAD_CAMERA_ICON, USER_WITH_CARD_ICON } from '@Images';
import { PUBLIC_PATH } from '@Utils/config';

class WebcamCapture extends React.Component {
  setRef = (webcam) => {
    this.webcam = webcam;
  };
  dataURLtoBlob = (dataurl) => {
    if (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  };
  capturePhoto = () => {
    const { formName, fileUploadName, onChangeFile, isIndependent = false } = this.props;
    const dataURL = this.webcam.getScreenshot();
    if (formName && fileUploadName && dataURL) {
      let imageObj = this.dataURLtoBlob(dataURL);
      let extension = imageObj.type;
      extension = '.' + extension.split('/')[1];
      let keyNames = fileUploadName.split('.'), //valid only for individual doc upload
        fileName = keyNames[2].replace(/_/g, ' ');
      fileName = fileName.replace('rfi id:', ''); // for rfi only
      onChangeFile({
        dataURL,
        fileName,
        extension,
        imageObj,
        fieldName: fileUploadName
      });
    } else if (isIndependent) {
      let imageObj = this.dataURLtoBlob(dataURL);
      let extension = imageObj.type;
      extension = '.' + extension.split('/')[1];
      onChangeFile({ dataURL, fieldName: fileUploadName, extension });
    }
    this.setState({ showCaptureBox: false, facingMode: true });
  };
  hideCapture = () => {
    const { fileUploadName, onChangeFile } = this.props;
    onChangeFile({
      dataURL: '',
      fileName: null,
      extension: null,
      imageObj: '',
      fieldName: fileUploadName
    });
    this.setState({ showCaptureBox: false, facingMode: true });
  };
  showCapture = () => {
    this.setState({ showCaptureBox: true });
  };

  constructor(props) {
    super(props);
    this.state = {
      showCaptureBox: false,
      facingMode: true //default 'user' facing mode
    };
    const { fileUploadName } = props;
    let keyNames = fileUploadName && fileUploadName.split('.'); //valid only for individual doc upload
    this.fileName = keyNames && keyNames[2];
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(null);
  }

  componentDidUpdate(prevProps) {
    // this will only work in India camera pop case
    if (prevProps.showCapturePoaCase !== this.props.showCapturePoaCase) {
      this.setState({ showCaptureBox: true });
    }
  }

  changeFacingMode = () => {
    this.setState({
      facingMode: !this.state.facingMode
    });
  };

  render() {
    const {
      fileUploadName,

      countryCode,
      currentScreen,
      accountType,
      device,
      disableForm,
      toggleFeature,
      input = {},
      isTakeAPicture,
      camLabel = 'Take a picture',
      poaCameraVisibility,
      showSampleModal,
      showCapturePoaCase,
      newRevampedtoggleFeature,
      captureMessage,
      showNewCaptureIcon
    } = this.props;

    let modalId = fileUploadName + '-',
      isPersonalImgUploadDoc = countryCode === 'SG' && currentScreen === SCREEN_NAME_PHOTO_UPLOAD;
    return [
      <div
        onClick={
          !showCapturePoaCase && poaCameraVisibility
            ? () => showSampleModal('camera')
            : this.showCapture
        }
        className="btn-doc-upload"
        key="btn-webcam"
        style={toggleFeature ? { border: 'none', margin: 0, padding: 0 } : {}}
      >
        {!toggleFeature && (
          <>
            {' '}
            <Image src={UPLOAD_CAMERA_ICON} className="icon" />
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
              }}
              id={
                this.fileName && this.fileName.replace(/[._]/g, '-').toLowerCase() + '-upload-file'
              }
            >
              {!disableForm && input.value && isTakeAPicture ? 'Take a Picture Again' : camLabel}
            </a>
          </>
        )}
        {toggleFeature && (
          <>
            {newRevampedtoggleFeature ? (
              <UploadButtonContainer>
                <img
                  className="user-with-card"
                  src={showNewCaptureIcon ? CAMERA_ICON : USER_WITH_CARD_ICON}
                  alt="camera"
                />
                <CommonButton type="link" text={captureMessage ?? 'Capture'} />
              </UploadButtonContainer>
            ) : (
              <div className="updc-upload-button">
                <img className="icon" src={UPLOAD_CAMERA_ICON} alt="camera" />
                <div className="icon-text">Camera</div>
              </div>
            )}
          </>
        )}
      </div>,
      !disableForm && (
        <Modal
          size="small"
          key="modal-webcam"
          className="webcam-modal"
          onClose={this.hideCapture}
          open={this.state.showCaptureBox}
          id={modalId + 'modal'}
        >
          <Modal.Header>{'Take a picture'}</Modal.Header>
          <Modal.Content>
            {device === DEVICE_MOBILE ? (
              <Webcam
                key={this.state.facingMode ? 'user-facing' : 'environment-facing'}
                audio={false}
                height={'100%'}
                ref={this.setRef}
                screenshotFormat="image/png"
                width={'100%'}
                videoConstraints={{
                  facingMode: {
                    exact: this.state.facingMode ? 'user' : 'environment'
                  }
                }}
                className={
                  'webcam-video-element ' + (isPersonalImgUploadDoc ? ' rotated-webcam' : '')
                }
              />
            ) : (
              <Webcam
                key={'environment'}
                audio={false}
                height={'100%'}
                ref={this.setRef}
                screenshotFormat="image/png"
                width={'100%'}
                className={
                  'webcam-video-element ' + (isPersonalImgUploadDoc ? ' rotated-webcam' : '')
                }
              />
            )}
            {isPersonalImgUploadDoc && accountType ? (
              <div className="webcam-overlay-div">
                <img
                  className="overlay-img"
                  src={`${PUBLIC_PATH}/images/webcam-frame-${accountType.toLowerCase()}.png`}
                  alt="webcam overlay"
                />
              </div>
            ) : null}
          </Modal.Content>
          <Modal.Actions className="cf">
            <Button
              negative
              onClick={this.hideCapture}
              id={modalId + 'btn-cancel'}
              className="btn-cancel"
            >
              {'Cancel'}
            </Button>
            <div className="camera-options">
              {this.props.device === DEVICE_MOBILE && (
                <Button
                  onClick={this.changeFacingMode}
                  id={modalId + 'btn-switch-cam'}
                  className="switch-cam-wrapper"
                >
                  <img
                    onClick={this.changeFacingMode}
                    src={CAMERA_FLIP_ICON}
                    alt="camera flip icon"
                    className="camera-flip-icon"
                  />
                </Button>
              )}
              <Button
                positive
                icon="camera"
                labelPosition="right"
                onClick={this.capturePhoto}
                content={'Capture'}
                id={modalId + 'btn-capture'}
                className="btn-capture"
              />
            </div>
          </Modal.Actions>
        </Modal>
      )
    ];
  }
}

WebcamCapture.propTypes = {
  onRef: PropTypes.func,
  showImage: PropTypes.func,
  dispatch: PropTypes.func,
  formSection: PropTypes.string,
  formName: PropTypes.string,
  fileUploadName: PropTypes.string,
  fileInfo: PropTypes.string,
  setFileData: PropTypes.func,

  updateFileInfo: PropTypes.func,
  countryCode: PropTypes.string,
  isPersonalImgUploadDoc: PropTypes.bool,
  accountType: PropTypes.string,
  onChangeFile: PropTypes.func,
  fileName: PropTypes.string,
  currentScreen: PropTypes.string,
  device: PropTypes.string,
  disableForm: PropTypes.bool,
  input: PropTypes.object,
  isTakeAPicture: PropTypes.bool,
  camLabel: PropTypes.bool,
  isIndependent: PropTypes.bool,
  toggleFeature: PropTypes.any,
  showCapturePoaCase: PropTypes.bool,
  poaCameraVisibility: PropTypes.bool,
  showSampleModal: PropTypes.func,
  newRevampedtoggleFeature: PropTypes.bool,
  captureMessage: PropTypes.string,
  showNewCaptureIcon: PropTypes.bool
};

function mapStateToProps(state) {
  const {
    rootReducer: {
      uiTriggerState: { device }
    }
  } = state;

  return { device };
}

//Connect form to language translater
export default connect(mapStateToProps, null)(WebcamCapture);
